import React from "react"
import PageLayout from "./pageLayout";

export const wrapPageElement = ({element, props}) => {
    return <PageLayout pageProps={props} pageEl={element} />
}